export const SUPPLIER_TYPES = {
  HOTEL: "HOTEL",
  RESTAURANT: "RESTAURANT",
  TRANSPORT: "TRANSPORT",
  EXCURSION: "EXCURSION",
  PARK: "PARK",
  TOUR_GUIDE: "TOUR_GUIDE",
  TOUR_LEADER: "TOUR_LEADER",
};

export const PRODUCT_TYPES = {
  ROOM: "ROOM",
  MEAL: "MEAL",
  TRANS: "TRANS",
  TOUR: "TOUR",
  EXPENSE: "EXPENSE",
  EXCURSION: "EXCURSION",
  TOUR_LEADER: "TOUR_LEADER",
};
